<template>
  <div class="small-logo pointer-hover" v-on:mouseover="mouseOver" v-on:mouseleave="mouseLeave" transition="logo">
    <canvas></canvas>
  </div>
</template>

<script>
import gsap from 'gsap'
import sprite from 'stupid-sprite'
import tick from 'stupid-tick'

export default {
  name: 'SmallLogo',
  data () {
    return {
      isHovered: false,
      endFrame: undefined,
      tick: undefined,
      sprite: undefined
    }
  },
  computed: {
    canvas () {
      return this.$el.querySelector('canvas')
    }
  },
  props: {
    images: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  ready () {
    this.tick = tick({fps: 25})

    this.sprite = sprite({
      tick: this.tick,
      canvas: this.canvas,
      loop: false
    })

    this.sprite
      .load(this.images)
      .success(this.success)

    this.sprite.on('ended', this.ended)
  },
  methods: {
    success () {
      this.endFrame = this.sprite.getEndFrame()
      this.sprite.reverse(true)
      this.sprite.play(this.endFrame)
    },
    ended () {
      if (this.isHovered && this.sprite.getFrame() === '0') {
        this.mouseOver()
      } else if (!this.isHovered && this.sprite.getFrame() === this.endFrame) {
        this.mouseLeave()
      }
    },
    mouseOver () {
      this.isHovered = true
      if (!this.sprite.hasLoaded() || this.sprite.isPlaying()) return
      this.sprite.reverse(false)
      this.sprite.play()
    },
    mouseLeave () {
      this.isHovered = false
      if (this.sprite.isPlaying()) return
      this.sprite.reverse(true)
      this.sprite.play()
    }
  },
  transitions: {
    logo: {
      enter (el, done) {
        gsap.to(this.$el, 0.5, {x: 0, opacity: 1, onComplete: () => {
          this.mouseLeave()
          done()
        }})
      },
      leave (el, done) {
        this.mouseOver()
        gsap.to(this.$el, 0.5, {x: -44, opacity: 0, onComplete: done})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.small-logo {
  width: 44px;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;

  canvas {
    width: 44px;
    height: 44px;
  }
}
</style>


// WEBPACK FOOTER //
// SmallLogo.vue?04701507